import { TableHeader, type TableHeaderRow } from '@shared/table-generator';

function getItemSetQuestionListTable(): TableHeaderRow[] {
  return [
    {
      children: [
        {
          id: 'row-padding',
          children: '',
          align: 'center',
          rowSpan: 1,
          width: 16,
          className: 'row-padding',
        },
        {
          id: 'no',
          children: 'No',
          align: 'center',
          rowSpan: 1,
          width: 60,
        },
        {
          id: 'chapter',
          children: 'Chapter',
          align: 'left',
          rowSpan: 1,
        },
        {
          id: 'topic',
          children: 'Topic',
          align: 'left',
          rowSpan: 1,
        },
        {
          id: 'subtopic',
          children: 'Subtopic',
          align: 'left',
          rowSpan: 1,
        },
        {
          id: 'type',
          children: 'Type',
          align: 'left',
          rowSpan: 1,
          width: 100,
        },
        {
          id: 'difficulty',
          children: 'Difficulty',
          align: 'center',
          rowSpan: 1,
          width: 100,
        },
        {
          id: 'blank',
          children: '',
          align: 'center',
          rowSpan: 1,
          width: 88,
        },
      ],
    },
  ];
}

export default function ItemSetQuestionListTableHeader() {
  const columns = getItemSetQuestionListTable();

  return (
    <TableHeader
      columns={columns}
      slotProps={{
        tableHeaderCell: {
          sx: (theme) => ({
            ...theme.typography.body1Semibold,
            backgroundColor: theme.palette.grey[100],
            padding: theme.spacing(0, 3),
            height: '48px',
            border: 'none',
            borderBottom: `1px solid ${theme.palette.divider}`,
            borderTop: `1px solid ${theme.palette.divider}`,
            '&.row-padding': {
              padding: 0,
            },
          }),
        },
      }}
    />
  );
}
